import script from "./DeskIndexView.vue?vue&type=script&setup=true&lang=js"
export * from "./DeskIndexView.vue?vue&type=script&setup=true&lang=js"

import "./DeskIndexView.vue?vue&type=style&index=0&id=8c2b615e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c2b615e"]])

export default __exports__